import React, { useState } from "react";
import { Mail, Globe, Send, Sparkles, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`FuturePath enquiry from ${form.name}`);
    const body = encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`);
    window.location.href = `mailto:futurepathleaening51@gmail.com?subject=${subject}&body=${body}`;
    toast.success("Opening your email client...");
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20 grid lg:grid-cols-5 gap-10">
      <div className="lg:col-span-2">
        <div className="overline mb-3">Get in touch</div>
        <h1 data-testid="contact-heading" className="text-4xl sm:text-5xl font-semibold text-brand-blue leading-tight">Talk to a real human.</h1>
        <p className="mt-4 text-lg text-brand-muted leading-relaxed">
          Questions about your child, our platform, partnerships, or press — we read every message.
        </p>

        <div className="mt-8 space-y-4">
          <a href="mailto:futurepathleaening51@gmail.com" data-testid="contact-email-link" className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-brand-border hover:border-brand-blue transition-colors">
            <div className="w-11 h-11 rounded-xl bg-brand-green-soft text-brand-green flex items-center justify-center"><Mail size={20} /></div>
            <div>
              <div className="text-xs text-brand-muted">Email</div>
              <div className="text-brand-blue font-medium">futurepathleaening51@gmail.com</div>
            </div>
          </a>
          <a href="https://future-path.in" target="_blank" rel="noreferrer" data-testid="contact-website-link" className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-brand-border hover:border-brand-blue transition-colors">
            <div className="w-11 h-11 rounded-xl bg-brand-orange-soft text-brand-orange flex items-center justify-center"><Globe size={20} /></div>
            <div>
              <div className="text-xs text-brand-muted">Website</div>
              <div className="text-brand-blue font-medium">future-path.in</div>
            </div>
          </a>
          <div className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-brand-border">
            <div className="w-11 h-11 rounded-xl bg-blue-50 text-brand-blue flex items-center justify-center"><ShieldCheck size={20} /></div>
            <div>
              <div className="text-xs text-brand-muted">Response time</div>
              <div className="text-brand-blue font-medium">Within 1-2 business days</div>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:col-span-3">
        <form onSubmit={submit} className="surface p-8 lg:p-10">
          <Sparkles className="text-brand-green mb-3" />
          <h2 className="text-2xl font-semibold text-brand-blue">Send us a note</h2>
          <p className="mt-1 text-sm text-brand-muted">Your message opens in your email client — no data leaves the browser.</p>
          <div className="mt-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-brand-blue mb-1.5">Your name</label>
              <input data-testid="contact-name-input" required className="field" value={form.name} onChange={set("name")} />
            </div>
            <div>
              <label className="block text-sm font-medium text-brand-blue mb-1.5">Email</label>
              <input data-testid="contact-email-input" required type="email" className="field" value={form.email} onChange={set("email")} />
            </div>
            <div>
              <label className="block text-sm font-medium text-brand-blue mb-1.5">Your message</label>
              <textarea data-testid="contact-message-input" required rows={6} className="field resize-none" value={form.message} onChange={set("message")} placeholder="Tell us about your child, family, or what you're looking for..." />
            </div>
            <button data-testid="contact-submit-btn" type="submit" className="btn-primary w-full">
              <Send size={16} /> Send message
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
